var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBpgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 24"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bpgIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bpgIcon_svg__b)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "bpgIcon_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 21,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 .44H2v24h21v-24z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bpgIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.236 3.484c2.244 1.28 4.311 1.863 6.85 2.037a.511.511 0 01.414.524v6.403c0 5.18-3.485 6.402-7.204 8.905-.178.116-.414.116-.532 0C9.044 18.85 5.5 17.628 5.5 12.448V6.045c0-.291.177-.465.473-.524 2.48-.174 4.606-.756 6.79-2.037.178-.058.355-.058.473 0z",
    stroke: "#fff",
    strokeWidth: 2,
    strokeMiterlimit: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.087 15.44v-1.102h.882v-2.153h-.882v-.924h.882v-1.04c0-.692.203-1.245.609-1.658.413-.42 1.036-.63 1.869-.63.413 0 .819.066 1.218.2.399.132.732.321.998.566l-.463.977a2.117 2.117 0 00-.808-.504 2.607 2.607 0 00-.882-.158c-.406 0-.707.102-.903.305-.196.196-.294.48-.294.85v1.092h1.743v.924h-1.743v2.153h3.202v1.102h-5.428z",
    fill: "#fff"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bpgIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h25v25H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bpgIcon_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2 .5h21v25H2z"
  })))));
}
export default SvgBpgIcon;